import {ExportMapDispatcher} from '../core/dispatchers'
import {IExportMapDispatcher} from '../core/interfaces/dispatchers'
class AppExportMapDispatcher extends ExportMapDispatcher {}

export const appExportMapDispatcher = new AppExportMapDispatcher() as IExportMapDispatcher
